import * as React from 'react';
import styled from 'styled-components/macro';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Menu, MenuItem, Button, Badge, Divider, ListItemIcon, ListItemText } from '@material-ui/core';
import { Grid, Avatar, Typography } from '@material-ui/core';
import {
  ArrowDropDown as IconArrowDropDown,
  AttachMoney as IconAttachMoney,
  Description as IconDescription,
  ChevronRight as IconChevronRight
} from '@material-ui/icons';

import { AppStateType } from '../../store/modules/root-reducer';
import * as authActions from '../../store/modules/auth/auth-actions';
import { formatMessage, formatNumber } from '../../i18n/translate';
import userService from '../../services/modules/user/user-service';
import { CurrentAccountModal } from '../CurrentAccountModal';

const SidebarFooterBadge = styled(Badge)`
  margin-right: ${props => props.theme.spacing(1)}px;
  span {
    background-color: ${props => props.theme.sidebar.footer.online.background};
    border: 1.5px solid ${props => props.theme.palette.common.white};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

const SidebarFooterText = styled(Typography)`
  text-align: left;
`;

const SidebarFooterSubText = styled(Typography)`
  text-align: left;
  font-size: 0.7rem;
  display: block;
  padding: 1px;
`;

const UserDropdown: React.FunctionComponent<any> = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: AppStateType) => state.auth ?? null);
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);
  const [isCurrentAccountOpen, setIsCurrentAccountOpen] = React.useState<boolean>(false);

  const canShowAccountBalance = !!auth?.user?.accountBalance;
  const currentBalanceAmount = auth?.user?.currentBalanceAmount ?? 0;

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = async () => {
    dispatch(authActions.logoutRequest());
  };

  const handleOpenAccountStatement = () => {
    setIsCurrentAccountOpen(true);
    closeMenu();
  };

  return (
    <>
      <Tooltip title="Account">
        <Button
          aria-owns={Boolean(anchorMenu) ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
        >
          <Grid container spacing={4}>
            <Grid item>
              <SidebarFooterBadge
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                variant="dot"
              >
                <Avatar alt={auth?.user?.nickname} src={auth?.user?.pictureURL} />
              </SidebarFooterBadge>
            </Grid>
            <Grid item style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: 12 }}>
                <SidebarFooterText variant="body2">{auth?.user?.nickname}</SidebarFooterText>
                <SidebarFooterSubText variant="caption">
                  {userService.parseUserRole(auth?.user?.userRole)}
                </SidebarFooterSubText>
              </div>
              <IconArrowDropDown />
            </Grid>
          </Grid>
        </Button>
      </Tooltip>
      <Menu id="menu-appbar" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
        {/* <MenuItem
          onClick={() => {
            closeMenu();
            history.push('/profile');
          }}
        >
          {formatMessage('commonAppbarMenuProfile')}
        </MenuItem> */}
        {canShowAccountBalance && (
          <>
            <MenuItem disabled>
              <ListItemIcon style={{ minWidth: 14, marginRight: 8 }}>
                <IconAttachMoney fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="body2" color="textPrimary">
                    {formatMessage('accountBalanceMenuLabel')}:{' '}
                    {formatNumber(currentBalanceAmount, { style: 'currency' })}
                  </Typography>
                }
              />
            </MenuItem>
            <MenuItem onClick={handleOpenAccountStatement}>
              <ListItemIcon style={{ minWidth: 14, marginRight: 8 }}>
                <IconDescription fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2">{formatMessage('accountBalanceMenuStatementLabel')}</Typography>}
              />
              <IconChevronRight fontSize="small" />
            </MenuItem>
            <Divider />
          </>
        )}
        <MenuItem onClick={handleSignOut}>{formatMessage('commonAppbarMenuLogout')}</MenuItem>
      </Menu>
      <CurrentAccountModal open={isCurrentAccountOpen} onClose={() => setIsCurrentAccountOpen(false)} />
    </>
  );
};

export default UserDropdown;
